var React = require('react');

function InfoIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 1a7 7 0 100 14A7 7 0 008 1zM0 8a8 8 0 1116 0A8 8 0 010 8z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 6.37H8a.5.5 0 01.5.5v5.5h-1v-5h-1v-1z","fill":"currentColor","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.5 12.37h-3v-1h3v1z","fill":"currentColor","key":2}),React.createElement("path",{"d":"M7.74 5.16a.77.77 0 01-.76-.77.76.76 0 011.52 0 .77.77 0 01-.76.77z","fill":"currentColor","key":3})]);
}

InfoIconInline.defaultProps = {"viewBox":"0 0 16 16","fill":"none","preserveAspectRatio":"xMidYMid meet","className":"r-1ghhsy9","style":{"height":"20px","verticalAlign":"middle","width":"20px"}};

module.exports = InfoIconInline;

InfoIconInline.default = InfoIconInline;
